export default __webpack_public_path__ + "static/media/speaker.43dd1fd4.png";